import { AJ_TYPES } from 'constants/enums'
import { activitiesParents } from 'redux/selectors/activities'
import { selectMap } from 'redux/selectors/misc'

const GET_VARIABLE_ACTIVITIES_LIST =
  'dofe-bo/activities/GET_VARIABLE_ACTIVITIES_LIST'
const GET_VARIABLE_ACTIVITIES_LIST_SUCCESS =
  'dofe-bo/activities/GET_VARIABLE_ACTIVITIES_LIST_SUCCESS'
const GET_VARIABLE_ACTIVITIES_LIST_FAIL =
  'dofe-bo/activities/GET_VARIABLE_ACTIVITIES_LIST_FAIL'
const GET_AJ_TYPES_ACTIVITIES_LIST =
  'dofe-bo/activities/GET_AJ_TYPES_ACTIVITIES_LIST'
const GET_AJ_TYPES_ACTIVITIES_LIST_SUCCESS =
  'dofe-bo/activities/GET_AJ_TYPES_ACTIVITIES_LIST_SUCCESS'
const GET_AJ_TYPES_ACTIVITIES_LIST_FAIL =
  'dofe-bo/activities/GET_AJ_TYPES_ACTIVITIES_LIST_FAIL'
const UPDATE_ACTIVITY = 'dofe-bo/activities/UPDATE_ACTIVITY'
const UPDATE_ACTIVITY_SUCCESS = 'dofe-bo/activities/UPDATE_ACTIVITY_SUCCESS'
const UPDATE_ACTIVITY_FAIL = 'dofe-bo/activities/UPDATE_ACTIVITY_FAIL'
const GET_ACTIVITIES = 'dofe-bo/activities/GET_ACTIVITIES'
const GET_ACTIVITIES_SUCCESS = 'dofe-bo/activities/GET_ACTIVITIES_SUCCESS'
const GET_ACTIVITIES_FAIL = 'dofe-bo/activities/GET_ACTIVITIES_FAIL'
const GET_ACTIVITY = 'dofe-bo/activities/GET_ACTIVITY'
const GET_ACTIVITY_SUCCESS = 'dofe-bo/activities/GET_ACTIVITY_SUCCESS'
const GET_ACTIVITY_FAIL = 'dofe-bo/activities/GET_ACTIVITY_FAIL'
const GET_ACTIVITY_LOGS = 'dofe-bo/activities/GET_ACTIVITY_LOGS'
const GET_ACTIVITY_LOGS_SUCCESS = 'dofe-bo/activities/GET_ACTIVITY_LOGS_SUCCESS'
const GET_ACTIVITY_LOGS_FAIL = 'dofe-bo/activities/GET_ACTIVITY_LOGS_FAIL'
const GET_ACTIVITY_LOG = 'dofe-bo/activities/GET_ACTIVITY_LOG'
const GET_ACTIVITY_LOG_SUCCESS = 'dofe-bo/activities/GET_ACTIVITY_LOG_SUCCESS'
const GET_ACTIVITY_LOG_FAIL = 'dofe-bo/activities/GET_ACTIVITY_LOG_FAIL'
const CREATE_ACTIVITY_LOG = 'dofe-bo/activities/CREATE_ACTIVITY_LOG'
const CREATE_ACTIVITY_LOG_SUCCESS =
  'dofe-bo/activities/CREATE_ACTIVITY_LOG_SUCCESS'
const CREATE_ACTIVITY_LOG_FAIL = 'dofe-bo/activities/CREATE_ACTIVITY_LOG_FAIL'
const REMOVE_ACTIVITY_LOG = 'dofe-bo/activities/REMOVE_ACTIVITY_LOG'
const REMOVE_ACTIVITY_LOG_SUCCESS =
  'dofe-bo/activities/REMOVE_ACTIVITY_LOG_SUCCESS'
const CREATE_ACTIVITY = 'dofe-bo/CREATE_ACTIVITY'
const CREATE_ACTIVITY_SUCCESS = 'dofe-bo/CREATE_ACTIVITY_SUCCESS'
const CREATE_ACTIVITY_FAIL = 'dofe-bo/CREATE_ACTIVITY_FAIL'
const REMOVE_ACTIVITY_LOG_FAIL = 'dofe-bo/activities/REMOVE_ACTIVITY_LOG_FAIL'
const EDIT_ACTIVITY_LOG = 'dofe-bo/activities/EDIT_ACTIVITY_LOG'
const EDIT_ACTIVITY_LOG_SUCCESS = 'dofe-bo/activities/EDIT_ACTIVITY_LOG_SUCCESS'
const EDIT_ACTIVITY_LOG_FAIL = 'dofe-bo/activities/EDIT_ACTIVITY_LOG_FAIL'
const GET_ACTIVITY_ASSESSMENT = 'dofe-bo/activities/GET_ACTIVITY_ASSESSMENT'
const GET_ACTIVITY_ASSESSMENT_SUCCESS =
  'dofe-bo/activities/GET_ACTIVITY_ASSESSMENT_SUCCESS'
const GET_ACTIVITY_ASSESSMENT_FAIL =
  'dofe-bo/activities/GET_ACTIVITY_ASSESSMENT_FAIL'
const APPROVE_ACTIVITY = 'dofe-bo/activities/APPROVE_ACTIVITY'
const APPROVE_ACTIVITY_SUCCESS = 'dofe-bo/activities/APPROVE_ACTIVITY_SUCCESS'
const APPROVE_ACTIVITY_FAIL = 'dofe-bo/activities/APPROVE_ACTIVITY_FAIL'
const SIGN_OFF_ACTIVITY = 'dofe-bo/activities/SIGN_OFF_ACTIVITY'
const SIGN_OFF_ACTIVITY_SUCCESS = 'dofe-bo/activities/SIGN_OFF_ACTIVITY_SUCCESS'
const SIGN_OFF_ACTIVITY_FAIL = 'dofe-bo/activities/SIGN_OFF_ACTIVITY_FAIL'

const CHANGE_STATE_ACTIVITY = 'dofe-bo/activities/CHANGE_STATE_ACTIVITY'
const CHANGE_STATE_ACTIVITY_SUCCESS =
  'dofe-bo/activities/CHANGE_STATE_ACTIVITY_SUCCESS'
const CHANGE_STATE_ACTIVITY_FAIL =
  'dofe-bo/activities/CHANGE_STATE_ACTIVITY_FAIL'

const ACTIVITY_CHANGE_ASSESSOR = 'dofe-bo/activities/ACTIVITY_CHANGE_ASSESSOR'
const ACTIVITY_CHANGE_ASSESSOR_SUCCESS =
  'dofe-bo/activities/ACTIVITY_CHANGE_ASSESSOR_SUCCESS'
const ACTIVITY_CHANGE_ASSESSOR_FAIL =
  'dofe-bo/activities/ACTIVITY_CHANGE_ASSESSOR_FAIL'

const SEND_ASSESSOR_REPORT = 'dofe-bo/activities/SEND_ASSESSOR_REPORT'
const SEND_ASSESSOR_REPORT_SUCCESS =
  'dofe-bo/activities/SEND_ASSESSOR_REPORT_SUCCESS'
const SEND_ASSESSOR_REPORT_FAIL = 'dofe-bo/activities/SEND_ASSESSOR_REPORT_FAIL'
const REMOVE_ACTIVITY_ASSESMENT = 'dofe-bo/activities/REMOVE_ACTIVITY_ASSESMENT'

const DELETE_ACTIVITY = 'dofe-bo/activities/DELETE_ACTIVITY'
const DELETE_ACTIVITY_SUCCESS = 'dofe-bo/activities/DELETE_ACTIVITY_SUCCESS'
const DELETE_ACTIVITY_FAIL = 'dofe-bo/activities/DELETE_ACTIVITY_FAIL'

const RESTORE_ACTIVITY = 'dofe-bo/activities/RESTORE_ACTIVITY'
const RESTORE_ACTIVITY_SUCCESS = 'dofe-bo/activities/RESTORE_ACTIVITY_SUCCESS'
const RESTORE_ACTIVITY_FAIL = 'dofe-bo/activities/RESTORE_ACTIVITY_FAIL'

const RESTORE_ACTIVITY_LOG = 'dofe-bo/activities/RESTORE_ACTIVITY_LOG'
const RESTORE_ACTIVITY_LOG_SUCCESS = `${RESTORE_ACTIVITY_LOG}_SUCCESS`
const RESTORE_ACTIVITY_LOG_FAIL = `${RESTORE_ACTIVITY_LOG}_FAIL`

const GET_ACTIVITY_REPORT = 'dofe-bo/activities/GET_ACTIVITY_REPORT'
const GET_ACTIVITY_REPORT_SUCCESS = `${GET_ACTIVITY_REPORT}_SUCCESS`
const GET_ACTIVITY_REPORT_FAIL = `${GET_ACTIVITY_REPORT}_FAIL`

const ACTIVITY_ASSESSMENT_RESEND =
  'dofe-bo/activities/ACTIVITY_ASSESSMENT_RESEND'
const ACTIVITY_ASSESSMENT_RESEND_SUCCESS =
  'dofe-bo/activities/ACTIVITY_ASSESSMENT_RESEND_SUCCESS'
const ACTIVITY_ASSESSMENT_RESEND_FAIL =
  'dofe-bo/activities/ACTIVITY_ASSESSMENT_RESEND_FAIL'

const ACTIVITY_SEND_WELCOME_EMAIL = 'dofe-bo/activities/ACTIVITY_SEND_WELCOME_EMAIL'
const ACTIVITY_SEND_WELCOME_EMAIL_SUCCESS = 'dofe-bo/activities/ACTIVITY_SEND_WELCOME_EMAIL_SUCCESS'
const ACTIVITY_SEND_WELCOME_EMAIL_FAIL = 'dofe-bo/activities/ACTIVITY_SEND_WELCOME_EMAIL_FAIL'

// refactor list to categories > { list: []}
const initialState = {
  list: [],
  activitiesList: [],
  parents: [],
  detail: {},
  mappedList: [],
  ajTypesList: [],
  logs: {
    list: [],
    listsByActivityId: {}
  },
  assessment: {
    data: {},
    loading: false
  },
  activityLog: {},
  loading: false,
  loaded: false,
  sending: false,
  reportSent: false
}

/* eslint-disable */
export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case GET_VARIABLE_ACTIVITIES_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_VARIABLE_ACTIVITIES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        list: action.result,
        mappedList: selectMap(action.result),
        parents: activitiesParents(action.result)
      }
    case GET_VARIABLE_ACTIVITIES_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ACTIVITIES:
      return {
        ...state,
        loading: true
      }
    case GET_ACTIVITIES_SUCCESS:
      return {
        ...state,
        activitiesList: action.result,
        loading: true,
        loaded: true
      }
    case GET_ACTIVITIES_FAIL:
      return {
        ...state,
        loading: true,
        error: action.error
      }
    case GET_ACTIVITY:
      return {
        ...state,
        loading: true
      }
    case GET_ACTIVITY_SUCCESS:
      return {
        ...state,
        detail: action.result,
        loading: false,
        loaded: true
      }
    case GET_ACTIVITY_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case GET_ACTIVITY_LOG:
      return {
        ...state,
        loading: true
      }
    case GET_ACTIVITY_LOG_SUCCESS:
      return {
        ...state,
        activityLog: action.result,
        loading: false,
        loaded: true
      }
    case GET_ACTIVITY_LOG_FAIL:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case GET_AJ_TYPES_ACTIVITIES_LIST:
      return {
        ...state,
        loading: true
      }
    case GET_AJ_TYPES_ACTIVITIES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        ajTypesList: selectMap(action.result)
      }
    case GET_AJ_TYPES_ACTIVITIES_LIST_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case UPDATE_ACTIVITY:
      return {
        ...state,
        loading: true
      }
    case UPDATE_ACTIVITY_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true
      }
    case UPDATE_ACTIVITY_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ACTIVITY_LOGS:
      return {
        ...state,
        loading: true
      }
    case GET_ACTIVITY_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        logs: {
          ...state.logs,
          list: action.result,
          listsByActivityId: {
            ...state.logs.listsByActivityId,
            [action.activityId]: action.result
          }
        }
      }
    case GET_ACTIVITY_LOGS_FAIL:
      return {
        ...state,
        loading: false,
        loaded: false,
        error: action.error
      }
    case GET_ACTIVITY_ASSESSMENT:
      return {
        ...state,
        assessment: {
          ...state.assessment,
          loading: true
        }
      }
    case GET_ACTIVITY_ASSESSMENT_SUCCESS:
      return {
        ...state,
        assessment: {
          ...state.assessment,
          loading: false,
          data: action.result
        }
      }
    case GET_ACTIVITY_ASSESSMENT_FAIL:
      return {
        ...state,
        assessment: {
          ...state.assessment,
          loading: false,
          error: action.error
        }
      }
    case ACTIVITY_ASSESSMENT_RESEND:
      return {
        ...state,
        loading: true
      }
    case ACTIVITY_ASSESSMENT_RESEND_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case ACTIVITY_ASSESSMENT_RESEND_FAIL:
      return {
        ...state,
        loading: false
      }
    case ACTIVITY_SEND_WELCOME_EMAIL:
      return {
        ...state,
        loading: true
      }
    case ACTIVITY_SEND_WELCOME_EMAIL_SUCCESS:
      return {
        ...state,
        loading: false
      }
    case ACTIVITY_SEND_WELCOME_EMAIL_FAIL:
      return {
        ...state,
        loading: false
      }
    case SEND_ASSESSOR_REPORT:
      return {
        ...state,
        sending: true
      }
    case SEND_ASSESSOR_REPORT_SUCCESS:
      return {
        ...state,
        sending: false,
        reportSent: true,
        error: null
      }
    case SEND_ASSESSOR_REPORT_FAIL:
      return {
        ...state,
        sending: false,
        reportSent: false,
        error: action.error
      }
    case REMOVE_ACTIVITY_ASSESMENT:
      return {
        ...state,
        assessment: {
          ...state.assessment,
          data: {}
        }
      }
    default:
      return state
  }
}

/* eslint-enable */

export function getActivitiesCategories(nested = false, parentId = false) {
  const nestedUrl = nested ? '?template=nested' : ''
  const parentFilter = parentId ? `?filter=parent.id=${parentId}` : ''

  return {
    types: [
      GET_VARIABLE_ACTIVITIES_LIST,
      GET_VARIABLE_ACTIVITIES_LIST_SUCCESS,
      GET_VARIABLE_ACTIVITIES_LIST_FAIL
    ],
    promise: client =>
      client.get(`api/activity-categories${nestedUrl}${parentFilter}`)
  }
}

export function getAjActivityTypes() {
  const ajTypeList = [
    AJ_TYPES.EXPLORATION,
    AJ_TYPES.EXPEDITION,
    AJ_TYPES.ADVENTUROUS_PROJECT,
    AJ_TYPES.VIRTUAL_SILVER_EXPEDITION,
    AJ_TYPES.VIRTUAL_BRONZE_EXPEDITION,
    AJ_TYPES.VIRTUAL,
    AJ_TYPES.PRACTICAL
  ]

  let types = ''

  ajTypeList.forEach(item =>
    types += `id=${item.id},`)

  return {
    types: [
      GET_AJ_TYPES_ACTIVITIES_LIST,
      GET_AJ_TYPES_ACTIVITIES_LIST_SUCCESS,
      GET_AJ_TYPES_ACTIVITIES_LIST_FAIL
    ],
    promise: client =>
      client.get(`api/activity-categories?filter=and(isActive=true,or(${types}))&template=nested`
      )
  }
}

export function getActivities () {
  return {
    types: [GET_ACTIVITIES, GET_ACTIVITIES_SUCCESS, GET_ACTIVITIES_FAIL],
    promise: client => client.get('api/activities')
  }
}

export function getActivity(id) {
  return {
    types: [GET_ACTIVITY, GET_ACTIVITY_SUCCESS, GET_ACTIVITY_FAIL],
    promise: client =>
      client.get(
        `api/activities/${id}?fields=(*,award(*),assessor(*,person(*)))`
      )
  }
}

export function getPublicActivity(id, authCode) {
  return {
    types: [GET_ACTIVITY, GET_ACTIVITY_SUCCESS, GET_ACTIVITY_FAIL],
    promise: client =>
      client.get(
        `api/activities/${id}/using-authorization-code?authorizationCode=${authCode}&with=AWARD,AWARD_ORGANIZATION,COMPLETED_PERCENTAGE,PARTICIPANT_DETAILS,ACTIVITY_CATEGORY,SECTION_HOURS_BREAKDOWN`,
        {
          removeToken: true,
          unauthorizedAction: false,
          isPublic: true
        }
      )
  }
}

export function sendActivityAssessorReport(id, authCode, data) {
  return {
    types: [
      SEND_ASSESSOR_REPORT,
      SEND_ASSESSOR_REPORT_SUCCESS,
      SEND_ASSESSOR_REPORT_FAIL
    ],
    promise: client =>
      client.post(
        `api/activities/${id}/assessor-reports/using-authorization-code?authorizationCode=${authCode}`,
        {
          data,
          removeToken: true,
          removeUserType: true,
          unauthorizedAction: false
        }
      )
  }
}

export function updateActivity(id, data) {
  return {
    types: [UPDATE_ACTIVITY, UPDATE_ACTIVITY_SUCCESS, UPDATE_ACTIVITY_FAIL],
    promise: client =>
      client.post(`api/activities/${id}/edit`, {
        data
      })
  }
}

export function createActivity(id, data) {
  return {
    types: [CREATE_ACTIVITY, CREATE_ACTIVITY_SUCCESS, CREATE_ACTIVITY_FAIL],
    promise: client => client.post(`api/awards/${id}/activities`, { data })
  }
}

export function setupActivity(id, data) {
  return {
    types: [UPDATE_ACTIVITY, UPDATE_ACTIVITY_SUCCESS, UPDATE_ACTIVITY_FAIL],
    promise: client =>
      client.post(`api/activities/${id}/setup`, {
        data
      })
  }
}

export function getActivityLogs(activityId) {
  return {
    types: [
      GET_ACTIVITY_LOGS,
      GET_ACTIVITY_LOGS_SUCCESS,
      GET_ACTIVITY_LOGS_FAIL
    ],
    promise: client =>
      client.get(
        `api/activity-logs?with=LOG_FILES,PRAISES&filter=activity.id=${activityId}&sort=-date`
      ),
    activityId
  }
}

export function getPublicActivityLogs(authCode) {
  return {
    types: [
      GET_ACTIVITY_LOGS,
      GET_ACTIVITY_LOGS_SUCCESS,
      GET_ACTIVITY_LOGS_FAIL
    ],
    promise: client =>
      client.get(
        `api/activity-logs/using-authorization-code?authorizationCode=${authCode}&sort=-date`,
        {
          unauthorizedAction: false,
          removeToken: true
        }
      )
  }
}

export function getActivityLog (id) {
  return {
    types: [GET_ACTIVITY_LOG, GET_ACTIVITY_LOG_SUCCESS, GET_ACTIVITY_LOG_FAIL],
    promise: client => client.get(`api/activity-logs/${id}?with=LOG_FILES`)
  }
}

export function createActivityLog(data) {
  return {
    types: [
      CREATE_ACTIVITY_LOG,
      CREATE_ACTIVITY_LOG_SUCCESS,
      CREATE_ACTIVITY_LOG_FAIL
    ],
    promise: client =>
      client.post('api/activity-logs', {
        data
      })
  }
}

export function removeActivityLog(id,  data) {
  return {
    types: [
      REMOVE_ACTIVITY_LOG,
      REMOVE_ACTIVITY_LOG_SUCCESS,
      REMOVE_ACTIVITY_LOG_FAIL
    ],
    promise: client => client.post(`api/activity-logs/${id}/delete`, { data })
  }
}

export function getActivityAssessment (activityId, activityActionId) {
  return {
    types: [
      GET_ACTIVITY_ASSESSMENT,
      GET_ACTIVITY_ASSESSMENT_SUCCESS,
      GET_ACTIVITY_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(`api/activities/${activityId}/assessments/${activityActionId}`)
  }
}

export function getActivityAssessmentRequests (activityId, activityActionId) {
  return {
    types: [
      GET_ACTIVITY_ASSESSMENT,
      GET_ACTIVITY_ASSESSMENT_SUCCESS,
      GET_ACTIVITY_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(
        `api/activities/${activityId}/assessment-requests/${activityActionId}`
      )
  }
}

export function getPublicActivityAssessmentRequests (
  activityId,
  activityActionId,
  authCode
) {
  return {
    types: [
      GET_ACTIVITY_ASSESSMENT,
      GET_ACTIVITY_ASSESSMENT_SUCCESS,
      GET_ACTIVITY_ASSESSMENT_FAIL
    ],
    promise: client =>
      client.get(
        `api/activities/${activityId}/assessment-requests/${activityActionId}/using-authorization-code?authorizationCode=${authCode}`,
        {
          removeToken: true,
          unauthorizedAction: false
        }
      )
  }
}

export function editActivityLog (id, data) {
  return {
    types: [
      EDIT_ACTIVITY_LOG,
      EDIT_ACTIVITY_LOG_SUCCESS,
      EDIT_ACTIVITY_LOG_FAIL
    ],
    promise: client =>
      client.post(`api/activity-logs/${id}/edit`, {
        data
      })
  }
}

export function approveActivity (id, data) {
  return {
    types: [APPROVE_ACTIVITY, APPROVE_ACTIVITY_SUCCESS, APPROVE_ACTIVITY_FAIL],
    promise: client =>
      client.post(`api/activities/${id}/approval`, {
        data
      })
  }
}

export function changeActivityState (id, state, data = {}) {
  return {
    types: [
      CHANGE_STATE_ACTIVITY,
      CHANGE_STATE_ACTIVITY_SUCCESS,
      CHANGE_STATE_ACTIVITY_FAIL
    ],
    promise: client =>
      client.post(`api/activities/${id}/state-change?state=${state}`, {
        data
      })
  }
}

export function signoffActivity (id, data) {
  return {
    types: [
      SIGN_OFF_ACTIVITY,
      SIGN_OFF_ACTIVITY_SUCCESS,
      SIGN_OFF_ACTIVITY_FAIL
    ],
    promise: client =>
      client.post(`api/activities/${id}/award-leader-signoff`, {
        data
      })
  }
}

export function resendActivityAssessmentRequest (id) {
  return {
    types: [
      ACTIVITY_ASSESSMENT_RESEND,
      ACTIVITY_ASSESSMENT_RESEND_SUCCESS,
      ACTIVITY_ASSESSMENT_RESEND_FAIL
    ],
    promise: client =>
      client.post(`api/activities/${id}/resend-assessment-requests`)
  }
}


export function sendAssessorWelcomeEmail (id) {
  return {
    types: [
      ACTIVITY_SEND_WELCOME_EMAIL,
      ACTIVITY_SEND_WELCOME_EMAIL_SUCCESS,
      ACTIVITY_SEND_WELCOME_EMAIL_FAIL
    ],
    promise: client =>
      client.post(`api/activities/${id}/send-assessor-welcome-email`)
  }
}

export function changeActivityAssessor (id, data) {
  return {
    types: [
      ACTIVITY_CHANGE_ASSESSOR,
      ACTIVITY_CHANGE_ASSESSOR_SUCCESS,
      ACTIVITY_CHANGE_ASSESSOR_FAIL
    ],
    promise: client =>
      client.post(`api/activities/${id}/change-assessor`, {
        data
      })
  }
}

export function removeActivityAssessment () {
  return {
    type: REMOVE_ACTIVITY_ASSESMENT
  }
}

export function deleteActivity (id) {
  return {
    types: [DELETE_ACTIVITY, DELETE_ACTIVITY_SUCCESS, DELETE_ACTIVITY_FAIL],
    promise: client => client.post(`api/activities/${id}/deletion`)
  }
}

export function restoreActivity (id) {
  return {
    types: [RESTORE_ACTIVITY, RESTORE_ACTIVITY_SUCCESS, RESTORE_ACTIVITY_FAIL],
    promise: client => client.post(`api/activities/${id}/undeletion`)
  }
}

export function restoreActivityLog (id) {
  return {
    types: [
      RESTORE_ACTIVITY_LOG,
      RESTORE_ACTIVITY_LOG_SUCCESS,
      RESTORE_ACTIVITY_LOG_FAIL
    ],
    promise: client => client.post(`api/activity-logs/${id}/undeletion`)
  }
}

export function getActivityReport (activityId) {
  return {
    types: [GET_ACTIVITY_REPORT, GET_ACTIVITY_REPORT_SUCCESS, GET_ACTIVITY_REPORT_FAIL],
    promise: client => client.get(`api/activities/${activityId}/summary-report-generation`)
  }
}
